import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCurrentStatesByOrdersInput } from './GetCurrentStatesByOrdersInput';
import { GetCurrentStatesByOrdersOutput } from './GetCurrentStatesByOrdersOutput';

export class GetCurrentStatesByOrdersService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetCurrentStatesByOrdersInput): Promise<Result<GetCurrentStatesByOrdersOutput> | null> => {
    const promise = this.http.post<Result<GetCurrentStatesByOrdersOutput>, GetCurrentStatesByOrdersInput>(`${this.baseUrlSislogApi}/v2/current-state`, input);
    return promise;
  }
}